import React from "react";
import { GatsbyImage } from "gatsby-plugin-image";
import { contractingProcess } from "../../config";

export const ContractingProcess = ({ image }) => {
  return (
    <div className="bg-white">
      <div className="flex flex-col mx-auto max-w-2xl px-8 py-16 lg:py-24 md:max-w-3xl lg:max-w-5xl xl:max-w-7xl">
        <h2 className="mt-2 text-3xl font-bold text-gray-900 tracking-tight sm:text-4xl text-center">
          4 pasos para contratar Bright
        </h2>
        <div className="relative mt-12 lg:mt-12 lg:grid lg:grid-cols-2 lg:gap-8 lg:items-center">
          <div className="relative">
            <ul role="list">
              {contractingProcess.map((step, index) => (
                <li key={step.number}>
                  <div className="relative pb-8">
                    {index !== contractingProcess.length - 1 ? (
                      <span className="absolute top-5 left-6 -ml-px h-full w-0.5 bg-gray-200" />
                    ) : null}
                    <div className="relative flex items-start space-x-6">
                      <>
                        <div className="relative">
                          <div className="inline-flex items-center justify-center p-3 bg-yellow-50 border-2 border-yellow-500 rounded-full h-12 w-12 text-yellow-500 font-bold text-xl">
                            {step.number}
                          </div>
                        </div>
                        <div className="min-w-0 flex-1">
                          <div>
                            <div className="text-xl font-semibold text-gray-900">
                              {step.title}
                            </div>
                          </div>
                          <div className="mt-3 prose text-gray-500">
                            <step.description />
                          </div>
                        </div>
                      </>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
            <div className="prose-sm text-gray-500">
              * Existen algunas situaciones de documentación que pueden demorar
              los trámites ante la CFE. Éstas no están bajo nuestro control pero
              es nuestra prioridad acelerar cualquier contratiempo que pudiera
              surgir
            </div>
          </div>

          <div className="mt-10 -mx-4 flex lg:mt-0 items-center justify-center">
            <GatsbyImage
              alt="Diagrama proceso de instalación Bright"
              className=""
              image={image}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
